export function isMobileApp(): boolean {
  try {
    const win: any = window;
    return !!win?.ReactNativeWebView;
  } catch (e) {
    return false;
  }
}
